module.exports = __webpack_public_path__ + "static/media/el-table-arrow.f2e76ad3.svg";